export default class AccountRoleType {
    static USER = 0;
    static EXECUTOR = 1;
    static ADMIN = 2;
    static INVENTORY_MANAGER = 3;
    static INVENTORY_VIEWER = 4;
}
